import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { call } from "./common";

export default function RedirectDialog({ rule, onClose, onDone }) {
  const [frm, setFrm] = useState(rule?.from_path || "");
  const [to, setTo] = useState(rule?.to_path || "");
  const [code, setCode] = useState(String(rule?.code || 301));
  const save = async () => {
    const r = rule
      ? await call(() => api.put(`/admin/url-repair/redirects/${rule.id}`, { to_path: to.trim(), code: Number(code) }), "Redirect updated")
      : await call(() => api.post("/admin/url-repair/redirects", { from_path: frm.trim(), to_path: to.trim(), code: Number(code) }), "Redirect added");
    if (r) { onDone(); onClose(); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-lg" data-testid="ur-redirect-dialog">
        <DialogHeader><DialogTitle>{rule ? "Edit redirect" : "Add manual redirect"}</DialogTitle></DialogHeader>
        <label className="text-sm font-semibold text-steel">Old URL or path</label>
        <Input value={frm} disabled={!!rule} onChange={(e) => setFrm(e.target.value)} placeholder="/product/old-url" className="font-mono text-xs" data-testid="ur-redirect-from" />
        <label className="text-sm font-semibold text-steel">Send to (page on this site)</label>
        <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="/product/new-url" className="font-mono text-xs" data-testid="ur-redirect-to" />
        <select value={code} onChange={(e) => setCode(e.target.value)} className="h-9 rounded-md border px-2 text-sm bg-white" data-testid="ur-redirect-code">
          <option value="301">301 — permanent (recommended)</option><option value="308">308 — permanent, keeps method</option><option value="302">302 — temporary</option></select>
        <p className="text-[11px] text-muted-foreground">The destination must be a live page on this site. Chains are flattened automatically and loops are blocked.</p>
        <Button onClick={save} className="bg-steel text-white" data-testid="ur-redirect-save">Save</Button>
      </DialogContent>
    </Dialog>
  );
}
